import { ExchangeOrder } from "TradeAPILib";

export default function isCopyOrder(item: ExchangeOrder) {
    return item.copyType === "copy_trade" && item.copyFrom;
}
